export const BASE_URL = document
  .getElementsByTagName('base')[0]
  .getAttribute('href')
  ?.replace(/\/$/, "")
